import { createFileRoute } from "@tanstack/react-router";
import Page from "@/pages/UploadDusterImages";
import { routeHead } from "@/lib/seo/route-head";

export const Route = createFileRoute("/admin/upload-duster/")({
  head: () => routeHead("/admin/upload-duster/"),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Page />
  );
}
